import { pgTable, uuid, text, timestamp, jsonb, index } from "drizzle-orm/pg-core";
import { organisations } from "./organisations";
export var InsightCategory;
(function (InsightCategory) {
    InsightCategory["GROWTH"] = "growth";
    InsightCategory["CHURN"] = "churn";
    InsightCategory["FINANCE"] = "finance";
    InsightCategory["OPERATIONS"] = "operations";
    InsightCategory["CUSTOMER_EXPERIENCE"] = "customer_experience";
    InsightCategory["MARKETING"] = "marketing";
    InsightCategory["CONVERSATION"] = "conversation";
})(InsightCategory || (InsightCategory = {}));
export const insights = pgTable("insights", {
    id: uuid("id").primaryKey().defaultRandom(), // unique insight id
    companyId: uuid("company_id")
        .notNull()
        .references(() => organisations.id, { onDelete: "cascade" }), // tenant boundary (FK to organisations.id)
    title: text("title"), // short human-readable headline
    bodyMd: text("body_md").notNull(), // full markdown body with explanation and links
    category: text("category"), // optional categorization (e.g., growth, churn, finance)
    confidence: text("confidence"), // free-form confidence (e.g., "high", "0.82"); can migrate to numeric later
    evidenceRefs: jsonb("evidence_refs").notNull().default({}), // provenance: { events:[], metrics:[], embeddings:[] }
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(), // creation timestamp
    supersedesId: uuid("supersedes_id"), // optional pointer if this supersedes a prior insight
}, table => ({
    companyCreatedIdx: index("idx_insights_company_created").on(table.companyId, table.createdAt),
    categoryIdx: index("idx_insights_category").on(table.category),
}));
